<template>
    <div class="sub-details">
        <h1>{{ subDetailTitle }}</h1>
        <div class="sub-details__content" v-for="(key, index) in Object.keys(subDetailContents)" :key="index">
            <p>{{ key }}</p>
            <p>{{ subDetailContents[key] }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "SubDetails",
    props: {
        subDetailTitle: String,
        subDetailContents: Object
    }
}
</script>
<style lang="scss" scoped>
  .sub-details {
        padding: 0 35px;

      &__content {
        padding: 15px 0;
        border-top: 1px solid #EBF0F4;
        border-bottom: 1px solid #EBF0F4;
      }

      h1 {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        color: #261940;
        padding: 10px 0;
      }

      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
        color: rgba(38, 25, 64, 0.6);
        padding: 4px 0;
      }
  }
</style>